import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { baseTheme } from 'themes/default';

const SettingsSlider = withStyles({
  thumb: {
    height: 30,
    width: 30,
    backgroundColor: baseTheme.palette.primary.main,
    border: `2px solid ${baseTheme.palette.common.white}`,
    marginTop: '-15px',
    marginLeft: '-15px',
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit'
    }
  },
  valueLabel: {
    left: 'calc(-50% + 10px)',
    top: 7,
    '& *': {
      background: 'transparent',
      color: baseTheme.palette.common.white,
      fontWeight: baseTheme.typography.fontWeightBold
    }
  },
  track: { backgroundColor: baseTheme.palette.grey.A200 },
  rail: {
    opacity: 0.5,
    backgroundColor: baseTheme.palette.grey.A200
  },
  mark: {
    backgroundColor: baseTheme.palette.common.white
  }
})(Slider);

export default SettingsSlider;
